/*eslint-disable */

import { bus } from '@/main';
import forwardMsgPopup from "@/components/private/mobile/workspace/forward-msg-popup/index.vue";
import { mapGetters } from 'vuex';

export default {
  name: 'message-search-popup',
  directives: {
    focus: {
      inserted: function (el) {
        el.focus()
      }
    }
  },
  components: {
    forwardMsgPopup
  },
  props: ['messageSearchForChatInfo', 'roomSocketUrl'],
  data () {
    return {
      selfUserId:'',
      selfUserInfo:null,
      chatInfo:null,
      search_term:'',
      searchMessageData:null,
      searchMessageResults:[],
      searchMessageActionState:false,
      msgSearchApiLoader:false,
      replyOnMessageBoxState:false,
      replyOnMessageData:null,
      sendMessageTxt:'',
      replyMsgForSeletedId:'',
      forwardMsgInfo:null,
      forwardMsgPopup:false
    }
  },
  computed: {
    ...mapGetters([
      'acUserDetailsStateGetters'
    ]),
    getselfUserInfoFun() {
      this.selfUserInfo = this.$store.getters.acUserDetailsStateGetters.data
      return;
    },
  },
  mounted () {
    this.getselfUserInfoFun
    this.selfUserId = localStorage.getItem('LoginedUserID')
    this.chatInfo = this.messageSearchForChatInfo
    bus.$on('forwardMsgPopupBus', (data) => {
      document.body.classList.add('body_right_scroll_remove')
      this.forwardMsgPopup = data
    })
  },
  methods: {
    newline(){},
    /*
     * This Will Checking Chat Message Position 
     */
    CheckingMessageSentReceivedPositionForRoomMethod(ChatData) {
      if(!ChatData) return;
      if(this.chatInfo && this.chatInfo.is_group_chat){
        if (ChatData.data.user_id == this.selfUserId) {
          return 'sent_message_of_search';
        } else {
          return 'received_message_of_search';
        }
      }else{
        if (ChatData.data.selfUserID == this.selfUserId) {
          return 'sent_message_of_search';
        } else {
          return 'received_message_of_search';
        }
      }
    },
    /*
    * This Will Message Search For Method
    */
    messageSearchFromRoomMethod(){
      if(this.search_term.length >= 3){
        this.searchMessageActionState = true
        this.msgSearchApiLoader = true
        let payload = {
          search_term:this.search_term,
          id:this.chatInfo.chat_room
        }
        this.$store.dispatch('getMessageSearchAction', payload).then((res) => {
          if(res.status == '200'){
            setTimeout(() => { 
              this.searchMessageData = res.data.data 
              this.searchMessageResults = this.searchMessageData.results
              this.msgSearchApiLoader = false
            })
          }
        }).catch((err) => {
          this.msgSearchApiLoader = false
        })
      }else{
        this.searchMessageData = null
        this.searchMessageResults = []
        this.searchMessageActionState = false
        this.msgSearchApiLoader = false
      }
    },
    clearSearchTermAction(){
      this.search_term = ''
      this.searchMessageActionState = false
      this.searchMessageData = null
      this.searchMessageResults = []
    },
    searchMessagePopupCloseMethod(){
      bus.$emit('messageSearchPopupStateBus', false)
      document.body.classList.remove('body_right_scroll_remove')
    },
    replyOnMessageViewOpenMethod(msgInfo){
      this.replyMsgForSeletedId = msgInfo.id
      this.replyOnMessageData = msgInfo
      this.replyOnMessageBoxState = true
      setTimeout(() => {
        // Set the scrollTop property of the element to its scroll height
        const element = document.getElementById('message_search_id');
        const tHeight = element.scrollHeight + parseInt('155')
        element.scrollTop = tHeight;
      }, 200);
    },
    replyOnMessageViewClosedMethod(){
      this.replyOnMessageData = null
      this.replyOnMessageBoxState = false
      this.replyMsgForSeletedId = ''
    },
    sendMessageOnSearchInGRoomMethod(){
      if(this.sendMessageTxt == '') return;
      let sendPayload = {
        'message': this.sendMessageTxt,
        type: 'sent',
        email: this.selfUserInfo.email,
        user_id: this.selfUserInfo.id,
        name: this.selfUserInfo.first_name + ' ' + this.selfUserInfo.last_name
      }
      const payload = {
        selfUserID: this.selfUserId,
        chatRoomId: this.chatInfo.id,
        senderMsgData: this.selfUserInfo.first_name + ' ' + this.selfUserInfo.last_name + ' : ' + this.sendMessageTxt,
        msgSenderFullName: this.chatInfo.name,
        second_user_id: this.chatInfo.id
      };
      if(this.replyMsgForSeletedId){
        this.roomSocketUrl.send(JSON.stringify({
          'message': this.sendMessageTxt,
          'user': this.selfUserId,
          'reply_to_msg': this.replyMsgForSeletedId,
          'chat_data': sendPayload
        }));
      }
      let socketTimeout = setTimeout(function () {
        bus.$emit('newChatMessageOfGroupRoom', payload);
        clearTimeout(socketTimeout);
      }, 2500);
      this.sendMessageTxt = ''
      this.searchMessagePopupCloseMethod();
    },
    sendMessageOnSearchInSRoomMethod(){
      if(this.sendMessageTxt == '') return;
      let sendPayload = {
        'message': this.sendMessageTxt,
        type: 'sent',
        email: this.chatInfo.user.email,
        user_id: this.chatInfo.user.id,
        name: this.chatInfo.user.first_name + ' ' + this.chatInfo.user.last_name,
        selfUserID: this.selfUserId,
        is_read: false,
      }
      const payload = {
        toUserID: this.chatInfo.user.id,
        second_user_id: this.chatInfo.user.id,
        fromUserID: this.selfUserId,
        chatRoomId: this.chatInfo.chat_room,
        senderMsgData: this.sendMessageTxt,
        msgSenderFullName: this.chatInfo.user.first_name + ' ' + this.chatInfo.user.last_name
      };
      if(this.replyMsgForSeletedId){
        this.roomSocketUrl.send(JSON.stringify({
          'message': this.sendMessageTxt,
          'user': this.chatInfo.user.id,
          'reply_to_msg': this.replyMsgForSeletedId,
          'chat_data': sendPayload
        }));
      }
      let socketTimeout = setTimeout(function () {
        bus.$emit('newChatMessage', payload);
        clearTimeout(socketTimeout);
      }, 2500);
      this.sendMessageTxt = ''
      this.searchMessagePopupCloseMethod();
    },
    forwardMsgToUserMethod(data) {
      document.body.classList.add('body_right_scroll_remove')
      this.forwardMsgPopup = true
      this.forwardMsgInfo = data
    },
  },
  watch:{
    getselfUserInfoFun() {
      return this.$store.getters.acUserDetailsStateGetters;
    },
  }
}